import api from "..";
import type { ICreateExtraCarPlateRequest } from "../extraCarPlate/type";
import type { IGetReceiptResponse } from "../payment/type";
import {
  type IAdyenCreateSessionResponse,
  type IAdyenLinkCardWithMonthlyOrderRequest,
  type IAdyenLinkCardWithMonthlyOrderResponse,
  type ICreateCustomerPortalResponse,
  type ICreateCustomSubscriptionRequest,
  type IGetAdyenStoredPaymentMethodsResponse,
  type IGetPaymentGatewayTypeResponse,
} from "./type";

export const createExtraCarPlateInStripe = async (
  token: string,
  extra_car_plates: ICreateExtraCarPlateRequest[]
) => {
  console.log("stripe mode");
  const response = await api.post(
    `/subscriptions/monthly_order/${token}/extra_car_plate`,
    {
      extra_car_plates,
    }
  );

  return response.data;
};

export const updateExtraCarPlateInStripe = async (
  token: string,
  extra_car_plate_ids: number[]
) => {
  console.log("stripe mode");
  const response = await api.delete(
    `/subscriptions/monthly_order/${token}/extra_car_plate`,
    {
      data: {
        extra_car_plate_ids,
      },
    }
  );
  return response.data;
};

export const createCustomerPortal = async (customerId: string) => {
  const response = await api.post<ICreateCustomerPortalResponse>(
    "/subscriptions/create-customer-portal",
    {
      customerId: customerId,
    }
  );
  return response.data;
};

// new set api of subscription apis for adyen

export const getMerchantAccountPaymentMethods = async () => {
  const response = await api.get(`/adyen/merchantPaymentMethods`);
  return response.data;
};

export const adyenGetPaymentMethods = async (
  shopperRef: string,
  storedPaymentMethodId: string
) => {
  const response = await api.get<IGetAdyenStoredPaymentMethodsResponse>(
    `/adyen/paymentMethods/${shopperRef}/${storedPaymentMethodId}`
  );
  return response.data;
};

export const getAvailablePaymentMethodType = async () => {
  const response = await api.get<IGetPaymentGatewayTypeResponse[]>(
    `/payment_method/getUseablePaymentMethods`
  );
  return response.data;
};

export const createCustomSubscription = async (
  data: ICreateCustomSubscriptionRequest
) => {
  const response = await api.post<any>(
    "/general_subscription/create-subscription",
    data
  );

  return response.data;
};

export const adyenCreditCardSingleCheckout = async (payment_id: number) => {
  const response = await api.post(
    `/general_subscription/adyenBindedCardSingleCheckout/${payment_id}`
  );
  return response.data;
};

export const adyenAlipayHKOrPaymeSingleCheckout = async (
  payment_id: number,
  returnUrl: string,
  isPayme?: boolean
) => {
  const response = await api.post<IAdyenCreateSessionResponse>(
    `/general_subscription/adyenAlipayHKOrPaymeSingleCheckout`,
    {
      payment_id,
      returnUrl,
      isPayme,
    }
  );
  return response.data;
};

export const precancelSubscription = async (monthly_order_id: string) => {
  const response = await api.post(
    `/general_subscription/precancelMonthlyOrder/${monthly_order_id}`
  );
  return response.data;
};

export const updateMonthlyOrderCreditCard = async (
  data: IAdyenLinkCardWithMonthlyOrderRequest,
  token: string
) => {
  const response = await api.post<IAdyenLinkCardWithMonthlyOrderResponse>(
    "/general_subscription/updateDefaultPaymentMethod",
    {
      ...data,
    },
    {
      headers: {
        authorization: "Bearer " + token,
      },
    }
  );
  return response.data;
};

export const removeMonthlyOrderCreditCard = async (
  paymentMethodId: string,
  shopperRef: string,
  token: string,
  monthlyOrderId: string
) => {
  const response = await api.delete<any>(
    `/general_subscription/removePaymentMethods`,
    {
      data: {
        paymentMethodId,
        shopperRef,
        monthlyOrderId,
      },
      headers: {
        authorization: "Bearer " + token,
      },
    }
  );

  return response.data;
};

export const createExtraCarPlate = async (
  token: string, // monthly order token
  extra_car_plates: ICreateExtraCarPlateRequest[]
) => {
  console.log("adyen mode");
  const response = await api.post(
    `/general_subscription/monthly_order/${token}/extra_car_plate`,
    {
      extra_car_plates,
    }
  );

  return response.data;
};

export const updateExtraCarPlate = async (
  token: string,
  extra_car_plate_ids: number[]
) => {
  console.log("adyen mode");
  const response = await api.delete(
    `/general_subscription/monthly_order/${token}/extra_car_plate`,
    {
      data: {
        extra_car_plate_ids,
      },
    }
  );
  return response.data;
};

export const generateSubscriptionReceipt = async (
  payment_id: number,
  userToken: string
) => {
  const response = await api.post<IGetReceiptResponse>(
    `/general_subscription/generateSubscriptionReceipt/${payment_id}`,
    {},
    {
      headers: {
        authorization: "Bearer " + userToken,
      },
    }
  );
  return response.data;
};

export const initAirwallexIntent = async (
  payment_id: number,
  returnUrl: string
) => {
  const response = await api.post<{
    intentId: string;
    clientSecret: string;
    status: string;
    amount: number;
    currency: string;
    merchantOrderId: string;
    returnUrl: string;
    metadata: {
      parkingSlot: string;
      userId: string;
    };
  }>(`/airwallex/payment-intent`, {
    payment_id,
    returnUrl,
  });
  return response.data;
};
